<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-house"></i>
          {{ $t("shop.shop_list") }}
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>
      <div class="column is-6" v-if="$can(['SuperAdmin','marketing','marketinghelper'])">
        <vs-button circle icon flat @click="OpenModalAdd()"
                   style="padding-left: 8px; padding-right: 8px; float: right">
          <i class="fal fa-plus-circle"></i>
        </vs-button>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-2">
          <div class="control">
            <label style="margin-right: 10px; margin-top: 2px;" class="label">
              {{ $t("shop.search") }}:
            </label>
            <input
                style="margin-top: 0.025rem;"
                class="input"
                type="text"
                name="searchItem"
                v-model="searchItem"
                @keyup.enter="FilterBySearch()"
            />
          </div>
        </div>
        <div v-if="$can(['SuperAdmin','marketing'])" class="column is-2">
          <div class="control">
            <label class="label">{{ $t("shop.shop_type") }}:</label>
            <div class="select">
              <select class="input" v-model="shop_type" @change="FetchData">
                <option value="">{{ $t("common.ທັງໝົດ") }}</option>
                <option value="hal">{{ $t("shop.hal_shop") }}</option>
                <option value="other">{{ $t("shop.partner_shop") }}</option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="$can(['marketinghelper'])" class="column is-2">
          <div class="control">
            <label class="label">{{ $t("shop.shop_type") }}:</label>
            <div class="select">
              <select class="input" v-model="shop_type" @change="FetchData">
                <option value="other">{{ $t("shop.partner_shop") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>{{ $t("shop.no") }}</vs-th>
            <vs-th>{{ $t("shop.image") }}</vs-th>
            <vs-th>{{ $t("shop.name") }}</vs-th>
            <vs-th>{{ $t("shop.tel") }}</vs-th>
            <vs-th>{{ $t("shop.shop") }}</vs-th>
            <vs-th>{{ $t("shop.main_shop") }}</vs-th>
            <vs-th v-if="shop_type === 'hal'">{{ $t("shop.linked_branch") }}</vs-th>
            <vs-th>{{ $t("shop.created_date") }}</vs-th>
            <vs-th>{{ $t("shop.status") }}</vs-th>
            <vs-th v-if="$can(['SuperAdmin','marketing','marketinghelper'])"></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="shop"
              v-for="(shop, index) in $vs.getPage(shops, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>
              <div v-if="shop.icon" class="img-size">
                <expandable-image
                    class="image"
                    :src=shop.icon
                ></expandable-image>
              </div>
            </vs-td>
            <vs-td>{{ shop.name }}</vs-td>
            <vs-td>{{ shop.tel }}</vs-td>
            <vs-td>{{ laType[shop.type] }}</vs-td>
            <vs-td v-if="shop.parent_name">{{ shop.parent_name }}</vs-td>
            <vs-td v-else>{{ $t("shop.main_shop") }}</vs-td>
            <vs-th v-if="shop_type === 'hal' && shop.branch_name">{{ shop.branch_name }}</vs-th>
            <vs-th v-else-if="shop_type === 'hal' && shop.branch_name == null">{{ $t("shop.branch_not_linked") }}</vs-th>
            <vs-td>{{ moment(shop.created_at).format('DD/MM/YYYY H:mm') }}</vs-td>
            <vs-td v-if="shop.status === 'open'" style="color: green">{{ laStatus[shop.status] }}</vs-td>
            <vs-td v-else style="color: red">{{ laStatus[shop.status] }}</vs-td>
            <vs-td style="text-align: right; width: 100px" v-if="$can(['SuperAdmin','marketing','marketinghelper'])">
              <div class="group-icon">
                <vs-button v-if="$can('SuperAdmin') && shop.parent_id != null && shop.type === 'hal'" circle icon flat
                           @click="OpenModalDelete(shop)">
                  <i class="fad fa-link"></i>
                </vs-button>
                <vs-button circle icon flat
                           @click="OpenModalEdit(shop)">
                  <i class="fad fa-pencil"></i>
                </vs-button>
                <vs-button v-if="shop.parent_id != null"
                           circle icon flat @click="printQr(shop)">
                  <i class="fad fa-print"></i>
                </vs-button>
                <vs-button danger
                           circle icon flat @click="OpenModalCancel(shop)">
                  <i class="fad fa-trash"></i>
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
    <ModalAdd>
      <template v-slot="{ close }">
        <AddShop @close="close" @success="FetchData()"/>
      </template>
    </ModalAdd>
    <ModalDelete>
      <template v-slot="{ close }">
        <LinkShop @close="close"
                  :item="linkBranch"
                  @success="FetchData()"/>
      </template>
    </ModalDelete>
    <ModalEdit>
      <template v-slot="{ close }">
        <EditShop @close="close"
                  :item="item"
                  @success="FetchData()"/>
      </template>
    </ModalEdit>
    <ModalCancel>
      <template v-slot="{ close }">
        <DeleteShop @close="close"
                  :item="item"
                  @success="FetchData()"/>
      </template>
    </ModalCancel>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/Pagination';
import * as helper from "@/Helpers/GetValue";
import AddShop from "@/views/ExchangeItem/Shop/Dialog/Add"
import EditShop from "@/views/ExchangeItem/Shop/Dialog/Edit"
import LinkShop from "@/views/ExchangeItem/Shop/Dialog/Delete"
import DeleteShop from "@/views/ExchangeItem/Shop/Dialog/DeleteShop"

export default {
  components: {
    Loading,
    pagination,
    AddShop,
    EditShop,
    LinkShop,
    DeleteShop
  },

  data() {
    return {
      laStatus: {
        'open': this.$t('shop.status_open'),
        'close': this.$t('shop.status_close')
      },
      laType: {
        'hal': this.$t('shop.type_hal'),
        'other': this.$t('shop.type_contract'),
        'event': this.$t('shop.type_event')
      },
      page: 1,
      max: 10,
      isLoading: true,
      shop_type: '',
      shops: [],
      item: {},
      linkBranch: {},
      searchItem: "",
      oldVal: "",
      // Pagination
      count: 0,
      offset: 10,
      limit_page: 10,
      pagination: {},
    };
  },
  watch: {
    'searchItem': function (value) {
      if (value === '') {
        this.FetchData();
      }
    },
  },
  methods: {
    printQr(item) {
      const loading = this.BtnLoading();
      this.loading = true;
      this.$http.post('print/shop/qr', {
            shop_id: item.id,
          },
          {responseType: 'blob'}
      ).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        fileLink.setAttribute('download', 'SHOP QR ' + item.name + '.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        this.loading = false;
        loading.close()
      }).catch(() => {
        this.loading = false;
        loading.close()
      })
    },
    FetchData() {
      this.isLoading = true;
      this.fetchInvoiceItemsResponse().then((res) => {
        setTimeout(() => {
          this.shops = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
          this.oldVal = ''
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchInvoiceItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('list/shop', {
        params: {
          search: this.searchItem,
          type: this.shop_type,
          isApp: 'no',
          page: current_page ?? this.pagination.current_page,
          per_page: per_page ?? this.limit_page,
        }
      })
    },
    OpenModalEdit(shop) {
      this.item = JSON.parse(JSON.stringify(shop));
      this.$store.commit("modalEdit_State", true);
    },
    OpenModalCancel(shop) {
      this.item = JSON.parse(JSON.stringify(shop));
      this.$store.commit("modalCancel_State", true);
    },
    OpenModalDelete(item) {
      this.linkBranch = JSON.parse(JSON.stringify(item));
      this.$store.commit("modalDelete_State", true);
    },
    OpenModalAdd() {
      this.$store.commit("modalAdd_State", true);
    },
    FilterBySearch() {
      helper.GetOldValueOnInput(this);
    },
    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
  mounted() {
    if (this.$can('marketinghelper')) {
      this.shop_type = 'other'
    } else {
      this.shop_type = '';
    }
  },
  created() {
    if (this.$can('marketinghelper')) {
      this.shop_type = 'other'
    } else {
      this.shop_type = '';
    }
    this.FetchData();
  },
};
</script>
<style lang="scss" scope>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}

</style>
